import React, { useState, useEffect, useMemo } from 'react';
import { useContent } from '../../../contexts/ContentContext';
import { useEditMode } from '../../../contexts/EditModeContext';
import InlineTranslationEdit from '../../../components/InlineTranslationEdit';
import RichContentRenderer from '../../../components/RichContentRenderer';
import {
  AboutFullPageEnabled,
  AboutFullPageTitle,
  AboutFullPageText,
} from '../../../content/keys';

export default function AboutTeamSection({ section }) {
  const { c, resolveContentValue } = useContent();
  const { editMode } = useEditMode();

  const showFullPage = c(AboutFullPageEnabled, '') === 'True';
  const fullPageTitle = c(AboutFullPageTitle, '');
  const fullPageText = c(AboutFullPageText, '');
  const renderedFullPageText = resolveContentValue(fullPageText, {
    currentKey: AboutFullPageText,
    editMode,
  });

  const isPlaceholder = (val, defaultKey) => {
    if (!val || typeof val !== 'string') return true;
    const clean = val.replace(/<[^>]*>/g, '').trim();
    if (!clean) return true;
    if (clean === defaultKey) return true;
    return /^(Contact|About)?\s*Full\s*Page\s*(Title|Text)?$/i.test(clean);
  };

  const hasContent = !isPlaceholder(fullPageTitle, AboutFullPageTitle) || !isPlaceholder(fullPageText, AboutFullPageText);

  if (!editMode && (!showFullPage || !hasContent)) return null;
  if (!fullPageTitle && !fullPageText && !editMode) return null;

  return (
    <div className="mb-8 sm:mb-16 md:mb-20">
      <div className="max-w-3xl mx-auto">
        {(fullPageTitle || editMode) && (
          <h2 className="text-xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-3 sm:mb-6 text-center">
            <InlineTranslationEdit translationKey={AboutFullPageTitle} value={fullPageTitle} />
          </h2>
        )}
        {fullPageText ? (
          <RichContentRenderer
            html={renderedFullPageText}
            className="text-xs sm:text-base text-gray-700 dark:text-gray-300 leading-relaxed"
          />
        ) : editMode ? (
          <p className="text-gray-500 dark:text-gray-400 text-center italic text-xs sm:text-base">
            <InlineTranslationEdit translationKey={AboutFullPageText} value="" multiline />
          </p>
        ) : null}
      </div>
    </div>
  );
}
